import { Button } from "../../client/components/ui/button";
import { RotateCcw, Check } from "lucide-react";
import useTranslation from "../../client/hooks/useTranslation";

export interface EditModeBarProps {
  onReset: () => void;
  onDone: () => void;
}

export default function EditModeBar({ onReset, onDone }: EditModeBarProps) {
  const t = useTranslation();
  return (
    <div
      role="region"
      aria-label={t.dashboard.customize}
      className="sticky top-14 z-30 mb-4 flex items-center gap-2 rounded-lg border border-primary/40 bg-background/80 backdrop-blur-sm px-3 py-2 shadow-sm"
    >
      <Button size="sm" variant="outline" onClick={onReset}>
        <RotateCcw className="h-4 w-4 mr-1" />
        {t.dashboard.resetLayout}
      </Button>
      <div className="flex-1" />
      <Button size="sm" variant="default" onClick={onDone}>
        <Check className="h-4 w-4 mr-1" />
        {t.dashboard.done}
      </Button>
    </div>
  );
}
